import api from '../../config/api_config';

export const vendorsApi = {
    // Public vendor endpoints
    getVendors: (params) => api.get('/vendors/', { params }),
    getVendorById: (id) => api.get(`/vendors/${id}/`),
    
    // Vendor registration
    registerVendor: (data) => api.post('/vendors/', data),
    
    // Current vendor profile (authenticated)
    getMyProfile: () => api.get('/vendors/me/'),
    updateMyProfile: (data) => api.patch('/vendors/me/', data),
    getDashboard: () => api.get('/vendors/dashboard/'),
    
    // Store images
    uploadStoreImage: (formData) => api.post('/vendors/upload_store_image/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }),
    deleteStoreImage: (imageId) => api.delete(`/vendors/store-image/${imageId}/`),
    
    // Products (for current authenticated vendor)
    getProducts: (params) => api.get('/vendors/me/products/', { params }),
    getProductById: (id) => api.get(`/vendors/me/products/${id}/`),
    createProduct: (data) => api.post('/vendors/me/products/', data, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }),
    updateProduct: (id, data) => api.patch(`/vendors/me/products/${id}/`, data),
    deleteProduct: (id) => api.delete(`/vendors/me/products/${id}/`),
    toggleProductActive: (id) => api.post(`/vendors/me/products/${id}/toggle_active/`),
    updateProductStock: (id, quantity) => api.post(`/vendors/me/products/${id}/update_stock/`, { quantity }),
    uploadProductImage: (productId, formData) => api.post(`/vendors/me/products/${productId}/upload_image/`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }),
    deleteProductImage: (productId, imageId) => api.delete(`/vendors/me/products/${productId}/image/${imageId}/`),
    
    // Orders (for current authenticated vendor)
    getOrders: (params) => api.get('/vendors/me/orders/', { params }),
    getOrderById: (id) => api.get(`/vendors/me/orders/${id}/`),
    updateOrderStatus: (id, status) => api.post(`/vendors/me/orders/${id}/update_status/`, { status }),
    getOrderStatistics: () => api.get('/vendors/me/orders/statistics/'),
    
    // Payouts
    getPayouts: (params) => api.get('/vendors/payouts/', { params }),
    
    // Public vendor products (by vendor ID)
    getVendorProducts: (vendorId) => api.get(`/vendors/${vendorId}/products/`),
    
    // Reviews
    getVendorReviews: (vendorId) => api.get(`/vendors/${vendorId}/reviews/`),
    addVendorReview: (vendorId, data) => api.post(`/vendors/${vendorId}/reviews/`, data)
};